import { APPLICANT_TYPES } from '../util/constants';
import { useApplicantData } from './useApplicantData';
import { getApplicantData } from '../util/helpers/applicantDataHelper';

const useApplicationJointOwnersCountries = () => {
  const MainApplicantData = useApplicantData(APPLICANT_TYPES.MAIN);
  const SecondaryApplicantData = useApplicantData(APPLICANT_TYPES.SECONDARY);

  const mainIdentityCountry = getApplicantData(
    MainApplicantData,
    'PersonCountry',
    'CountryIso3Code',
  );

  const secondaryIdentityCountry = getApplicantData(
    SecondaryApplicantData,
    'PersonCountry',
    'CountryIso3Code',
  );

  return {
    mainIdentityCountry,
    secondaryIdentityCountry,
  };
};

useApplicationJointOwnersCountries.propTypes = {};

export default useApplicationJointOwnersCountries;
